// extracted by mini-css-extract-plugin
module.exports = {"tableBuilder":"TableBuilder_tableBuilder__m8jxc"};